import { render } from "./ParentCard.vue?vue&type=template&id=2ce6e9b6&scoped=true"
import script from "./ParentCard.vue?vue&type=script&lang=js"
export * from "./ParentCard.vue?vue&type=script&lang=js"

import "./ParentCard.vue?vue&type=style&index=0&id=2ce6e9b6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce6e9b6"]])

export default __exports__